import { useMutation } from '@tanstack/react-query';
import { ChatRequests } from 'src/requests/chat';
import { useUpdateMessage } from 'src/sections/@dashboard/chat/ChatConversation/useUpdateMessage';

type Props = {
  channelId: string;
  goToMessage: string | undefined;
};

export const useMessageReactions = ({ channelId, goToMessage }: Props) => {
  const { updateMessage } = useUpdateMessage({ channelId, goToMessage });

  const { mutateAsync: reactMessage, isLoading: isReactingMessage } =
    useMutation({
      mutationFn: ChatRequests.reactMessage,
      onSuccess: (message) => {
        updateMessage(message);
      },
    });

  return {
    reactMessage,
    isReactingMessage,
  };
};
